// extracted by css-extract-rspack-plugin
export default {"text":"ay7bB","bouncing":"enulV","balanceInt":"gUlJM","balanceDec":"WzOo7"};